import router from "../router";

export default {
    filters: {
        vatExcluder(value) {
            if (router.currentRoute.meta.isBusiness === true || 'zakelijk' in router.currentRoute.query) {
                value = (value / (1 + (drupalSettings.vat_percentage) / 100)).toFixed(2);
            }

            return value;
        },

        currencyFormatter(value) {
            if (!lodash.isNumber(lodash.toNumber(value))) {
                return value;
            }

            const numberFormatter = new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
            });

            return numberFormatter
                .format(lodash.toNumber(value))
                .replace(',00', ',-')
                .replace('€', '')
                .trimStart();
        },
    },

    methods: {
        checkDecimals(value) {
            if (lodash.isNaN(value) || value === null || value === undefined) {
                return value;
            }

            if (value.toString().includes(',-')) {
                return value
            }

            const priceParts = value.toString().split(",");
            return `${priceParts[0]},<sup>${priceParts[1]}</sup>`;
        }
    }
}
